import axios from 'axios';
import { StockCheckRequest } from '../models/StockCheck';

export const ProductService = {
  GetProducts: async (businessUnit: string | undefined) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/product?businessUnit=${businessUnit}`,
    );
    return response;
  },
  GetProductsByLanguage: async (idLanguage: string) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/product/language/${idLanguage}`,
    );
    return response;
  },
  StockCheck: async (items: StockCheckRequest[]) => {
    console.log('StockCheck items', items);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/Product/validate-stock`,
      items,
    );
    return response;
  },
};
